<script setup lang="ts"></script>

<template>
  <span :class="$style.accentMarker">
    <slot></slot>
  </span>
</template>

<style lang="scss" module>
@use '_constants.scss' as *;
.accentMarker {
  background: linear-gradient(transparent 64%, $color-orange-300 0%);
}
</style>
